import React from "react";

import FormInput from "../FormInput/FormInput";

export default function FormPasswordInput(props) {
	return <FormInput type="password" {...props} />;
}
